import getEnv from '@settings/getEnv';
import { useEffect } from 'react';
import useWebSocket from 'react-use-websocket';

import useDelivery from '../../useDelivery';
import { RouteSearchTaskStatusResponse } from './RoutesCalculationLoader/types';

const { REACT_APP_TRANSPORT_WS_SERVER } = getEnv();

export function useRouteSearchTaskStatusSubscribe() {
  const { useRouteSearchTaskId, useCalculationAbortController, actions } = useDelivery();
  const { updateRouteSearchTaskStatus, resetRouteSearchTaskStatus } = actions;
  const [routeSearchTaskId] = useRouteSearchTaskId().useState();
  const [calculdationAbortController] = useCalculationAbortController().useState();

  const { lastJsonMessage, sendJsonMessage, getWebSocket } = useWebSocket(
    REACT_APP_TRANSPORT_WS_SERVER,
    {
      onOpen: () => {
        if (!routeSearchTaskId) return;
        sendJsonMessage({
          taskId: routeSearchTaskId,
          action: 'identify',
        });
        updateRouteSearchTaskStatus({
          baseGraphBuildIsDone: false,
          buildRoutesIsDone: false,
          calculateGroupsIsDone: false,
          groupRoutesIsDone: false,
          taskId: routeSearchTaskId,
          typeSearch: 'SEARCH_COMPLETE_ROUTES',
        });
      },
    }
  );

  useEffect(() => {
    const abortHandler = () => {
      const socket = getWebSocket();
      if (socket && socket.readyState === WebSocket.OPEN) {
        socket.close(1000, 'Aborted by controller');
      }
    };
    calculdationAbortController.signal.addEventListener('abort', abortHandler);

    return () => {
      calculdationAbortController.signal.removeEventListener('abort', abortHandler);
    };
  }, [calculdationAbortController]);

  useEffect(() => {
    if (!routeSearchTaskId) {
      const socket = getWebSocket();
      if (socket) {
        socket.close(4000, 'Reconnecting');
      }
    }
  }, [routeSearchTaskId]);

  useEffect(() => {
    if (!lastJsonMessage) return;

    const lastMessage = lastJsonMessage as RouteSearchTaskStatusResponse;

    updateRouteSearchTaskStatus(lastMessage.message, () => {
      const socket = getWebSocket();
      if (socket) {
        socket.close(4000, 'Reconnecting');
      }
    });
  }, [lastJsonMessage]);

  useEffect(() => {
    return () => {
      const socket = getWebSocket();
      if (socket) {
        socket.close(4000, 'Reconnecting');
      }
      resetRouteSearchTaskStatus();
    };
  }, []);
}
